import { Map } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actions.SET_MENU_DATA_PROCESSING:
      return state.set('processing', action.payload)
    case actions.SET_MENU_DATA:
      return state.withMutations((mutateState) => {
        return mutateState
          .set('processing', action.payload.processing)
          .set('data', action.payload.data.menuData)
          .set('metaData', action.payload.data.menuMetaData)
      })
    default:
      return state
  }
}
